export default __webpack_public_path__ + "static/texture-yellow-dots-06-e429902235ee9307e63985746ca4fa08.png";